var map = {
	"./cnn-money-x2.png": 2068,
	"./cnn-money.png": 2282,
	"./economist-x2.png": 2069,
	"./economist.png": 2283,
	"./mashable-x2.png": 2070,
	"./mashable.png": 2284,
	"./tech-crunch-x2.png": 2071,
	"./tech-crunch.png": 2285,
	"./thenewyorker-x2.png": 2072,
	"./thenewyorker.png": 2286,
	"./thrillist-x2.png": 2073,
	"./thrillist.png": 2287,
	"./time-x2.png": 2074,
	"./time.png": 2288,
	"./usa-today-x2.png": 2075,
	"./usa-today.png": 2289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2281;